import type {
  MentionNotification,
  ReactionNotification,
} from 'types/notification'

export type DiscussionMixpanelType = 'mention' | 'reaction'

const DISCUSSION_NOTIFICATION_EVENT_TYPE: Record<
  MentionNotification['type'] | ReactionNotification['type'],
  DiscussionMixpanelType
> = {
  discussions_receive_mention: 'mention',
  discussions_receive_reaction: 'reaction',
}

export function getDiscussionMixpanelProperties(
  notification: MentionNotification | ReactionNotification,
): Record<string, string> {
  return {
    type: DISCUSSION_NOTIFICATION_EVENT_TYPE[notification.type],
    visibility: notification.visibility ?? 'internal',
    ...(notification.type === 'discussions_receive_reaction'
      ? { reaction_type: notification.reaction_type }
      : {}),
  }
}
